// extracted by mini-css-extract-plugin
export default {"bg_image":"LogInComponent_bg_image__7ctdK"};